const imgUrl2 =
  "https://winpeforum.com/assets/elements/women_leaders_press.webp";
const imgUrl3 = "https://winpeforum.com/assets/elements/nupur_garg_article.png";
const imgUrl4 = "https://winpeforum.com/assets/elements/Nupur_press_img.png";
const imgUrl5 = "https://winpeforum.com/assets/elements/Bala_c.png";
const imgUrl6 = "https://winpeforum.com/assets/elements/nupur_300x225.jpg";
const imgUrl7 = "https://winpeforum.com/assets/elements/WinpeProclub_press.jpg";
const imgUrl8 = "https://winpeforum.com/assets/elements/Business_Standard.jpg";
const imgUrl9 = "https://winpeforum.com/assets/elements/Business_World.jpg";
const imgUrl10 = "https://winpeforum.com/assets/elements/Outlook_India.jpg";
const imgUrl11 = "https://winpeforum.com/assets/elements/The_Week.jpg";
// const icon12 = "https://winpeforum.com/assets/elements/blog_page_image.jpg"
const imgUrlFE = "https://winpeforum.com/assets/elements/Financial-Express.jpg";
const imgUrlET = "https://winpeforum.com/assets/elements/ETlogo.jpg";
const pop1 = "https://winpeforum.com/assets/elements/nupur_garg.jpg";
const pop2 = "https://winpeforum.com/assets/elements/Bala_c_p.png";
const v1 = "https://www.youtube.com/watch?v=-lbdoRHEw2E";
const v2 = "https://www.youtube.com/watch?v=sPC-C9QOsTY&t=9s";
const v3 = "https://www.youtube.com/watch?v=jbknJ9kEyMY";
const v4 = "https://www.youtube.com/watch?v=8ZWEtz0VY10&t=61s";
const v5 = "https://www.youtube.com/watch?v=-UMc3Re85vE";
const v6 = "https://www.youtube.com/watch?v=SAIrOt_fPnU";
const v7 = "https://www.youtube.com/watch?v=F3dDI7r-8-U&t=62s";
const v8 = "https://www.youtube.com/watch?v=bqI1N1aX2XI";
const v9 = "https://www.youtube.com/watch?v=8GEfatC55mM";
const v10 = "https://www.youtube.com/watch?v=gmzCeJVypc4";
const v11 = "https://www.youtube.com/watch?v=X3lqRf7AspU";
const v12 = "https://www.youtube.com/watch?v=wusQ6pp973k";
const v13 = "https://www.youtube.com/watch?v=f3VsoEpcJUU";
const v14 = "https://www.youtube.com/watch?v=l1n_3J4qBcI";

const moneycontrol = "https://winpeforum.com/assets/elements/money-control.jpg";

const ibtn9 = "https://winpeforum.com/assets/elements/ibtn9logo.jpg";

const techgraph = "https://winpeforum.com/assets/elements/techgraph.jpg";
const asiaone = "https://winpeforum.com/assets/elements/asiaone-300X225-02.jpg";
const ivca = "https://winpeforum.com/assets/elements/ivca-300X225-01.jpg";

const yourstorynupur = "https://winpeforum.com/assets/elements/yourstory-press-nupur-garg.jpg";

const businessnewsthisweek =
  "https://winpeforum.com/assets/elements/business_news_this_week.jpg";

  const bweducation =
  "https://winpeforum.com/assets/elements/bwedu.jpg";

  const fortune =
  "https://winpeforum.com/assets/elements/fortune.jpg";
const vccircle = "https://winpeforum.com/assets/elements/vccircle.jpg"
const pe ="https://winpeforum.com/assets/elements/peilogo.jpg";
const bloomberg ="https://winpeforum.com/assets/elements/bloomberg.png";
const et ="https://winpeforum.com/assets/elements/et.jpg";
const cnbc="https://winpeforum.com/assets/elements/cnbctv18.png";
const pehal="https://winpeforum.com/assets/elements/pehal.png";
const inc="https://winpeforum.com/assets/elements/inc42.png";
const she="https://winpeforum.com/assets/elements/shethepeople.png";
const outlook= "https://winpeforum.com/assets/elements/outlook.png"
const mint= "https://winpeforum.com/assets/elements/mint.png"
const toi= "https://winpeforum.com/assets/elements/toi.png"
const ent= "https://winpeforum.com/assets/elements/ent-india.png"
const trak= "https://winpeforum.com/assets/elements/trak.png"
const bwdisrupt =
  "https://winpeforum.com/assets/elements/BWdisrupt.png";
  const businessnews =
  "https://winpeforum.com/assets/elements/businessnews.png";
  const contentmedia =
  "https://winpeforum.com/assets/elements/contentmedia.png";
  const passionate =
  "https://winpeforum.com/assets/elements/passionate.png";
  const biznewsdesk =
  "https://winpeforum.com/assets/elements/biznewsdesk.png";
  const peoplematter = "https://winpeforum.com/assets/elements/peoplematters.png"
    const startuptalky = "https://winpeforum.com/assets/elements/StartupTalky.png"
 const ht = "https://winpeforum.com/assets/elements/ht.png"


const TabContent = [
  {
    id: 4,
    tabName: "Knowledge Resources",
  },
  {
    id: 5,
    tabName: "Newsletters",
  },
];

const blogsContent = [
  {
    id: 1,
    title: "My LP musings",
    subtitle: "Nupur Garg",
    bimg: imgUrl3,
    popImg: pop1,
    date: " 27th March 2020",
    link: "https://winpeforum.com/assets/elements/nupur_garg_artical1.jpg",
    into:
      " ",
    desc: `<div>Nupur Garg is a leading investor in private equity and venture capital
and an expert advisor to large institutional investors. She is the
founder of Winpe, an initiative to enhance gender diversity in the
investing ecosystem.<br/><br/>
Nupur serves as Chairperson of the board of Kids Clinic India
Limited (Cloudnine chain of hospitals) and an independent director
on the boards of Edelweiss Real Assets Managers Limited and
Molbio Diagnostics Limited. She is an advisor to and a member of
the investment committee for the Dutch Good Growth Fund
(DGGF) investment funds mandate given by the Dutch government
for investments in SMEs in frontier markets across 75 countries.<br/><br/>
Nupur has served two terms on the board of SIDBI, the Indian DFI,
as an early member of the investment committee at the Fund of Funds managed by the National
Investment and Infrastructure Fund (NIIF), the quasi-sovereign wealth fund sponsored by the government
of India and on the investment committee for the INR 10,000 crore Fund of Fund for Start-ups for
investing in the Indian start-up ecosystem; guiding the development of their investment programs. Nupur
advises select fund managers on a confidential basis on matters related to institutionalization, best practices
and governance. She also mentors female entrepreneurs across various platforms.<br/><br/>
Nupur is recognized as a thought and industry leader with a list of recognitions that include the Private
Equity International Most Influential Women (global) 2024, BW VC World Most Influential Women 2024,
2023 and 2022, HerPower Award 2023, Forbes W-Power list of Self Made Women 2020, India’s top 10
Women Leaders in Finance (AIWMI 2019), Vedica Women’s Alliance’s Women Leader in D&I 2022,
Women Empowerment Entrepreneur Award 2019-20 and the Business Excellence and Innovative Best
Practices - Academia Award 2019.<br/><br/>
In her previous role, Nupur led the private equity and venture capital funds business in the region for IFC
and is widely credited with establishing IFC’s brand and credibility as one of the most respected
institutional investors in this space. Under her stewardship, the portfolio doubled in size and returns,
moving from a negative IRR to delivering gains for the first time in its history.<br/><br/>
Nupur is a CA and an MBA from MIT Sloan School of Management, with executive education from
Harvard Business School.<br/><br/>
Nupur loves to spend time with her mother, husband and 10-year-old son, travel to new places, read and
do 1500-piece puzzles.
		</div>`,
    name: "Nupur Garg",
    post: "Founder, Winpe Development Forum",
    details: `<div>The impact of COVID-19 has been broad and far-reaching, the cascading effects will continue to unfold in the near future. But it is clear that no person, society, business or economy will remain untouched by the crippling effect of this pandemic that has brought the global machinery to a painful halt.
			<br />
			<br />
			As an investor in funds, I can well imagine the stress on portfolio companies and consequently on the investing industry as a whole. This is the time for the toughest fund managers to stand tall, proactively support their portfolio companies and be on the look-out for that great asset that could come by at a superb price. 
			<br />
			<br />
			I can't help but think that this is going to set the industry back once again, wiping out portfolio performance just when Indian PE had started recovering from the stigma of delivering sub-par returns. The VC space, which has rapidly developed into being an attractive investment option for LPs would be severely affected as well before having the opportunity to mature. That said, the one difference between this crisis and the previous one is that all markets will feel the impact around the same time and in some manner be comparable to each other. The last time round, what hit Indian PE hardest was the currency devaluation that staggered in after the GFC and that positioned the Indian industry's performance adversely relative to other markets, especially developed markets. There may be less blame attributed to 'India' than the pandemic. In a manner, this also means that real performance will continue to count, maybe more than before.
			<br />
			<br />
			A friend asked me how I think LPs would respond to this. I am not sure and I can’t speak for everyone, yet one thing is obvious - the fund raising journey looks a little unpredictable right now. The non-institutional LPs including HNIs and FOs may be hit with significant erosion in wealth, leading to a rejig in their investment portfolios as also priorities. Now I would think that institutional LPs, like everyone else, would be keen to get on with their business and their business is investing. The questions they ask about potential investment opportunities would generally stay the same and they would continue to focus on the risk reward profile. But some answers would change and the decision making framework would alter to reflect the new reality. This could mean a change in allocation between asset classes. And honestly, wealth erosion is happening for institutional LPs as well and there is little analysis yet on how their financial positions will be affected. We are probably looking at reduced investments outlays on an aggregate basis.
			<br />
			<br />
			A lot depends on how different markets, assets and currencies perform under this stress. The developed markets versus emerging markets debate, market versus manager, equity versus credit, listed versus unlisted, specialized versus generalist etc – these debates have always existed and will take on a new form as new information flows in. This is the time to sense make and gather inputs.
			<br />
			<br />
			So what do I recommend fund managers to focus on in addition to their portfolio companies- 
			<br />
			<br />
			1. Communicating with investors is key. Proactively sharing with investors what is happening in the economy (relevant especially for overseas investors), impact on the portfolio and what are the steps being taken to support portfolio companies. It doesn't have to be a deep view on what could happen to the economy, just the fund manager's own thoughtful assessment of what is going on.  
			<br />
			<br />
			2. Rethink the engagement and funding strategy for the portfolio and rethink future investment plans not only in the context of the macro changes, but also in the context of what the revised portfolio return and liquidity profile looks like. Do we need to allocate more follow-on capital for the portfolio? Do we need some quick wins? Do we need to redo the sector strategy to get there or do we need to change the nature of the target business to get there? Share with investors. 
			<br />
			<br />
			3. For fund managers that have the ability to, I think in times like this, a demonstration of strong alignment with LPs can go a long way. For example, a token cut in management fee and/or a moratorium or deferral of management fee to reset the impact on LP IRR would be a gesture incredibly hard to find fault with.
			<br />
			<br />
			It is quite clear that cash is going to be king and funds with dry powder will be the best placed to navigate this phase, supporting portfolio companies and adding good bets to the portfolio. The journey could be tougher for funds in exit mode and those planning a fund raise. A strong relationship with LPs based on transparency, good governance, sound investing principles and active portfolio engagement will stand fund managers in good stead. In any case, by all investing principles, the coming years offer good investing vintages that LPs should be happy to participate in, everything else remaining equal. But will it?
		</div>`,
  },
  {
    id: 2,
    title: "The Stockdale Paradox",
    subtitle: "Bala C Deshpande",
    bimg: imgUrl5,
    popImg: pop2,
    date: " 18th May 2020",
    link: "https://winpeforum.com/assets/elements/Bala_c.png",
    into:
      " ",
    desc: `<div>Bala C Deshpande is the Senior Managing Partner at MegaDelta Capital Advisors. Bala has nearly two decades of experience in investment advisory, having started her investing career with ICICI Venture in 2001. In 2008 she joined NEA to set up their India platform where she headed the practice for 10 years and helped NEA US in investing and backing disruptive companies in the mid-market space. Prior to her investing experience, Bala had deep operational experience having worked for about 10 years with well-regarded multi-national corporations in India such as ICI, Cadbury’s and Best Foods.
		<br />
		<br />
		Her investment advisory career spans both early stage and growth investing experience across multiple sectors. She has played an instrumental role in many innovative plays and entrepreneurial journeys including the first Internet IPO, first 24-hour news channel, first Payments Tech company, several consumer companies that redefined the sector etc. She is an Independent Board member of two deeply disruptive companies viz. Info Edge Ltd and Future Enterprise Limited. During her Board Tenure these companies have grown exponentially, emerged as category leaders and created immense shareholder value with multi-billion-dollar market caps.
		<br />
		<br />
		She is passionate about Technology and its far-reaching implications on markets, businesses and consumers. She seeks to back and help build disruptive businesses and entrepreneurs who redefine markets and create lasting economic value.
		</div>`,
    name: "Bala C Deshpande",
    post: "Senior Managing Partner, MegaDelta Capital Advisors",
    details: `<div>As I write this piece in the locked down world for Winpe, whose heart and soul is about inclusion, I
				marvel at the fact that a virus surpassed humanity in terms of its complete and absolutely unbiased
				inclusiveness. No race, no gender, no profession, no competency level, no one, but no one is
				discriminated against.
			<br />
			<br />
			I wish we had been so all encompassing in our economic world and been much more inclusive.
			Because the truth is that though the pandemic is a risk for everyone alike, the impact and the
			economic ramifications thereof differ deeply and widely.
			<br />
			<br />
			To state the obvious, the biggest factor that will impact a Person, Business or a Country is access to
			Capital and thereafter how effectively the available capital will be used. First to survive then to win
			against the attendant pandemic of economic contraction. As of today, the richest and most well-
			heeled have taken the lead in employing capital as a powerful vaccine - The US FED with its multi
			trillion dollar support programs, China with its FX gambit, India’s largest market cap company with
			its unprecedented capital raise from a multi-billion dollar US enterprise.
			<br />
			<br />
			Alas we all know that capital tends to flock and flow prodigiously to the big, the bold and the
			beautiful. More so in India. So the question begging an answer is what about the rest of the
			businesses that work very hard at raising capital even in a normal world? Will COVID-19 result in
			more selectiveness, more exclusion than inclusion by the capital purveyors?
			<br />
			<br />
			I believe in the short run inevitably YES. In the long run (what is that? ☺) capital will return to seek
			super normal return especially in the VC and Private capital world. This is THE question that is being
			asked to us investors in multiple forums in multiple forms. My take away from all these zillion
			conversations is that investments in the VC and PE world will be back soon. How soon? Pick a
			number, 6 months ? A year? I for one, am not hazarding a guess, I’d rather wait than predict.
			<br />
			<br />
			What I do strongly believe though is that rules of the game will change. The rules of how we build
			businesses, how we invest in them and last but the most critical what kind of entrepreneurs we will
			back. Since the heart of this change, as always, is the entrepreneur, let me focus on that.
			<br />
			<br />
			An entrepreneur’s interpretation of the external world in normal circumstances or crises is a very
			critical starting point. It defines the strategic responses and actions deeply influencing the outcomes
			of survival, failure or success. It can also become the key differentiating factor between two
			competing businesses.
			<br />
			<br />
			Here is the rub though, the calls we make are so insouciant and natural to ourselves, that we fail to recognize the in-built biases that we operate from. To illustrate, let me take the case of this pandemic. I have seen entrepreneurs of extremely young companies who continue to believe that life is going to slip back to “normalcy” and we would return to BAU.
			<br />
			<br />
			I hope so, for their sake. But I truly believe that entrepreneur who is self-aware, who understands the implications of his own thoughts and actions, fights for the best outcome but prepares for the worst is the one who is going to attract the dollars going forward. This DNA filter will be employed very strictly going forward.
			<br />
			<br />
			I think this tenet is aptly summarised by the Stockdale Paradox, named after Admiral Stockdale a POW in Vietnam for 8 years with no Prisoner rights, no set release date, no certainty of survival as he was brutalised many times over. He did survive and was set free. When asked how he achieved
			freedom when so many others did not, the gist of his answer was this.
			<br />
			<br />
			“You must maintain unwavering faith that you can and will prevail in the end, regardless of the
			difficulties, AND at the same time have the discipline to confront the brutal facts of your current
			reality, whatever they might be.”
			<br />
			<br />
			<strong>So true that for entrepreneurs, investors alike.</strong>
		</div>`,
  },
];

const pressContent = [
  // (https: //winpeforum.com/assets/elements/ibtn9logo.jpg
  {
    id: 5,
    pname: "Business World | BW Education",
    title:
      "RBI Draft FDI Rules 2026 May Ease Downstream Investments By Foreign Entities",
    bimg: bweducation,
    date: "July 2026 | Article",
    link:
      "https://www.businessworld.in/article/rbi-draft-fdi-rules-2026-may-ease-downstream-investments-by-foreign-entities-617471",
    type: "link",
  },
  {
    id: 5,
    pname: "Hindustan Times",
    title: "DEI works when it evolves organically",
    bimg: ht,
    date: "Aug 2025 | Article",
    link:"https://www.hindustantimes.com/ht-insight/gender-equality/dei-works-when-it-evolves-organically-101755605076691.html",    
    type: "link",
  },
  {
    id: 5,
    pname: "The Economic Times",
    title: "Are women truly empowered in leadership, or just riding a new wave of bias",
    bimg: et,
    date: "Nov 2024 | Article",
    link:"https://economictimes.indiatimes.com/small-biz/hr-leadership/leadership/are-women-truly-empowered-in-leadership-or-just-riding-a-new-wave-of-bias/articleshow/115831235.cms",    
    type: "link",
  },
  {
    id: 5,
    pname: "StartupTalky",
    title: "Empowering Change: Nupur Garg on Promoting Gender Diversity in Private Equity and Venture Capital",
    bimg: startuptalky,
    date: "Sep 2024 | Article",
    link:"https://startuptalky.com/nupur-garg-winpe-gender-diversity-pe-vc-insights/",    
    type: "link",
  },
  {
    id: 5,
    pname: "people matters",
    title: "Breaking biases, building careers: Nupur Garg’s vision for an equitable investing ecosystem",
    bimg: peoplematter,
    date: "July 2024 | Podcast",
    link:"https://www.peoplematters.in/article/diversity/breaking-biases-building-careers-nupur-gargs-vision-for-an-equitable-investing-ecosystem-42197",    
    type: "link",
  },
  {
    id: 5,
    pname: "The Economic Times",
    title: "Women are taking stock: As more women enter the high-net-worth category, their investment choices are also changing",
    bimg: et,
    date: "July 2024 | Article",
    link:"https://economictimes.indiatimes.com/news/india/women-are-taking-stock-as-more-women-enter-the-high-net-worth-category-their-investment-choices-are-also-changing/articleshow/111026029.cms?from=mdr",    
    type: "link",
  },
  {
    id: 5,
    pname: "The Times of India",
    title: "Dhan Ki Baat | Women in finance: Addressing the gender gap",
    bimg: toi,
    date: "June 2024 | Video",
    link:"https://timesofindia.indiatimes.com/videos/spotlight/dhan-ki-baat-women-in-finance-addressing-the-gender-gap/videoshow/110799314.cms",    
    type: "link",
  },
  
  {
    id: 5,
    pname: "Private Equity International",
    title:
      "Why India’s vast LP opportunity remains largely untapped",
    bimg: pe,
    date: "June 2024 | Article",
    link:
      "https://www.privateequityinternational.com/why-indias-vast-lp-opportunity-remains-largely-untapped/",
    type: "link",
  },
  {
    id: 5,
    pname: "The Economic Times",
    title: "PE-VC sector's Laapataa Ladies",
    bimg: et,
    date: "June 2024 | Article",
    link:"https://economictimes.indiatimes.com/opinion/et-commentary/pe-vc-sectors-laapataa-ladies/articleshow/110883132.cms?from=mdr",    
    type: "link",
  },
  {
    id: 5,
    pname: "The Economic Times",
    title: "Winpe joins hands with PwC India for second edition of Winpe Leadership Awards",
    bimg: et,
    date: "March 2024 | Press Coverage",
    link:"https://economictimes.indiatimes.com/small-biz/sme-sector/winpe-joins-hands-with-pwc-india-for-second-edition-of-winpe-leadership-awards/articleshow/108485032.cms",    
    type: "link",
  },
  {
    id: 5,
    pname: "Business News This Week",
    title: "Winpe Leadership Summit and Awards makes a comeback; Winpe joins hands with PwC India to celebrate trailblazers in gender diversity at the Winpe Leadership Awards",
    bimg: businessnews,
    date: "March 2024 | Press Coverage",
    link:"https://businessnewsthisweek.com/business/winpe-leadership-summit-and-awards-makes-a-comeback/",    
    type: "link",
  },
  {
    id: 5,
    pname: "Content Media Solution",
    title: "Winpe Leadership Summit and Awards makes a comeback; Winpe joins hands with PwC India to celebrate trailblazers in gender diversity at the Winpe Leadership Awards",
    bimg: contentmedia,
    date: "March 2024 | Press Coverage",
    link:"https://contentmediasolution.com/business/winpe-leadership-summit-and-awards-makes-a-comeback/",    
    type: "link",
  },
  
  {
    id: 5,
    pname: "Passionate in Marketing",
    title: "Winpe Leadership Summit and Awards makes a comeback; Winpe joins hands with PwC India to celebrate trailblazers in gender diversity at the Winpe Leadership Awards",
    bimg: passionate,
    date: "March 2024 | Press Coverage",
    link:"https://www.passionateinmarketing.com/winpe-leadership-summit-and-awards-makes-a-comeback-winpe-joins-hands-with-pwc-india-to-celebrate-trailblazers-in-gender-diversity-at-the-winpe-leadership-awards/",    
    type: "link",
  },
  {
    id: 5,
    pname: "Biz News Desk",
    title: "Winpe Leadership Summit and Awards makes a comeback; Winpe joins hands with PwC India to celebrate trailblazers in gender diversity at the Winpe Leadership Awards",
    bimg: biznewsdesk,
    date: "March 2024 | Press Coverage",
    link:"https://biznewsdesk.com/business/winpe-leadership-summit-and-awards-makes-a-comeback/",    
    type: "link",
  },
  
  
  {
    id: 5,
    pname: "Inc 42",
    title:"Crafting The Perfect Fundraising Pitch: Essential Tips For Startup Founders",
    bimg: inc,
    date: "March 2024 | Article",
    link:
      "https://inc42.com/resources/crafting-the-perfect-fundraising-pitch-essential-tips-for-startup-founders/",
    type: "link",
  },
  {
    id: 5,
    pname: "Inc 42",
    title:"Why India Need More Women Role Models In PE/VC Landscape?",
    bimg: inc,
    date: "November 2023 | Article",
    link:
      "https://inc42.com/resources/why-india-need-more-women-role-models-in-pe-vc-landscape/",
    type: "link",
  },
  {
    id: 5,
    pname: "Outlook Start-Up",
    title: "Why ESG does not include gender?",
    bimg: outlook,
    date: "October 2023 | Article",
    link:"https://startup.outlookindia.com/analysis/why-esg-does-not-include-gender--news-9575#:~:text=ESG%20guidelines%20emphasise%20an%20organisation's,in%20influencing%20businesses%20and%20societies",    
    type: "link",
  }, 
  {
    id: 5,
    pname: "Trak",
    title: "This Platform Empowers Women To Become Leaders, Entrepreneurs, Investors & Change-Makers",
    bimg: trak,
    date: "Sep 2023 | Article",
    link:"https://trak.in/stories/exclusive-interview-this-platform-empowers-women-to-become-leaders-entrepreneurs-investors-change-makers/",    
    type: "link",
  },
  {
    id: 5,
    pname: "BW Disrupt",
    title: "Gender-diverse Teams Excel In Decision-making, Growth: Founder Winpe",
    bimg: bwdisrupt,
    date: "July 2023 | Article",
    link:"https://bwdisrupt.businessworld.in/article/Gender-diverse-Teams-Excel-In-Decision-making-Growth-Founder-Winpe/04-07-2023-482956/",    
    type: "link",
  },
  {
    id: 5,
    pname: "Entrepreneur India",
    title: "The Promise of Startup Pivot    ",
    bimg: ent,
    date: "June 2023 | Article",
    link:"https://www.entrepreneur.com/en-in/news-and-trends/the-promise-of-startup-pivot/453388",    
    type: "link",
  },
  {
    id: 5,
    pname: "The Times of India",
    title: "How women investors can help build women’s entrepreneurial ecosystem",
    bimg: toi,
    date: "March 2023 | Article",
    link:"https://timesofindia.indiatimes.com/blogs/voices/how-women-investors-can-help-build-womens-entrepreneurial-ecosystem/",    
    type: "link",
  },
  {
    id: 5,
    pname: "Mint",
    title: "Why Gender Lens Investing may not be the only panacea we think it is",
    bimg: mint,
    date: "March 2023 | Article",
    link:"https://www.livemint.com/companies/start-ups/why-gender-lens-investing-may-not-be-the-only-panacea-we-think-it-is-11678195160053.html",    
    type: "link",
  },
  {
    id: 5,
    pname: "VCCiRCLE",
    title: "The Importance Of Gender Diversity For The PE/VC Ecosystem",
    bimg: vccircle,
    date: "March 2023 | Article",
    link:"https://www.vccircle.com/columnthe-importance-of-gender-diversity-for-the-pe-vc-ecosystem",    
    type: "link",
  },
  {
    id: 5,
    pname: "Mint",
    title: "What ails the PE and VC industry in gender diversity",
    bimg: mint,
    date: "January 2023 | Article",
    link:"https://www.livemint.com/opinion/columns/what-ails-the-pe-and-vc-industry-in-gender-diversity-11674673703717.html",    
    type: "link",
  },
  {
    id: 5,
    pname: "Outlook Start-Up",
    title: "Why women remain minority participants in India's investment landscape",
    bimg: outlook,
    date: "December 2022 | Article",
    link:"https://startup.outlookindia.com/investors/why-women-remain-minority-participants-in-india-s-investment-landscape-news-6965",    
    type: "link",
  },
  {
    id: 5,
    pname: "The Economic Times",
    title: "How the ‘Queen Bee’ syndrome is affecting gender diversity",
    bimg: et,
    date: "December 2022 | Article",
    link:"https://m.economictimes.com/small-biz/entrepreneurship/how-the-queen-bee-syndrome-is-affecting-gender-diversity/articleshow/96126311.cms",    
    type: "link",
  },
  {
    id: 5,
    pname: "shethepeople",
    title: "Nupur Garg Is On A Mission To Bring Gender Equality In PEVC Industry",
    bimg: she,
    date: "November 2022 | Interview",
    link:
      "https://www.shethepeople.tv/women-entrepreneurs/nupur-garg-pevc-industry/",
    type: "link",
  },
  {
    id: 5,
    pname: "Financial Express",
    title: "Women Entrepreneurship Day: Women entrepreneurs can bring positive changes in society’",
    bimg: imgUrlFE,
    date: "November 2022 | Article",
    link:
      "https://www.financialexpress.com/lifestyle/women-entrepreneurship-day-women-entrepreneurs-can-bring-positive-changes-in-society/2853942/",
    type: "link",
  },
  {
    id: 5,
    pname: "Financial Express",
    title: "Gender-diverse boardrooms: A stepping stone for more women in leadership roles",
    bimg: imgUrlFE,
    date: "September 2022 | Article",
    link:
      "https://www.financialexpress.com/jobs/gender-diverse-boardrooms-a-stepping-stone-for-more-women-in-leadership-roles/2671940/",
    type: "link",
  },
  {
    id: 5,
    pname: "The Economic Times",
    title: "Woman in the board room – Is it mission accomplished? not yet",
 
    bimg: et,
    date: "May 2022 | Opinion",
    link:"https://economictimes.indiatimes.com/small-biz/hr-leadership/leadership/woman-in-the-board-room-is-it-mission-accomplished-not-yet/articleshow/91556695.cms?utm_source=contentofinterest&utm_medium=text&utm_campaign=cppst",    
    type: "link",
  },
  {
    id: 5,
    pname: "Inc 42",
    title:
      "Only 15% Indian Unicorns Have Women Founders, Bridging Gender Divide Still A Work In Progress      ",
    bimg: inc,
    date: "May 2022 | Article",
    link:
      "https://inc42.com/buzz/only-15-indian-unicorns-have-women-founders-bridging-gender-divide-still-a-work-in-progress/",
    type: "link",
  },
  {
    id: 5,
    pname: "VCCiRCLE",
    title:
      "More women join PE/VC firms, but negligible progress on representation at the top: Winpe-BCG Report      ",
    bimg: vccircle,
    date: "March 2022 | Press Coverage",
    link:
      "https://www.vccircle.com/more-women-join-pe-vc-firms-but-negligible-progress-on-representation-at-the-top-winpe-bcg-report",
    type: "link",
  },
  {
    id: 5,
    pname: "The Economic Times",
    title: "Here's how venture capital firms can reduce the gender gap in investing",
    bimg: et,
    date: "March 2022 | Press Coverage",
    link:
      "https://m.economictimes.com/small-biz/entrepreneurship/heres-how-vc-firms-can-reduce-the-gender-gap-in-investing/amp_articleshow/89921907.cms",
    type: "link",
  },
  {
    id: 5,
    pname: "CNBC TV 18",
    title: "How VC firms can reduce the gender gap in investing: Winpe-BCG Report",
    bimg: cnbc,
    date: "March 2022 | Press Coverage",
    link:
      "https://www.cnbctv18.com/startup/startup-digest-ashneer-grover-resigns-as-bharatpe-md-director-bigbasket-completes-58-cr-deliveries-in-2021-google-meta-face-penalties-in-russia-12664902.htm",
    type: "link",
  },
  {
    id: 5,
    pname: "Financial Express",
    title: "Gender gap in private equity and venture capital firms improves, but more ground to cover",
    bimg: imgUrlFE,
    date: "March 2022 | Press Coverage",
    link:
      "https://www.financialexpress.com/industry/gender-gap-in-private-equity-and-venture-capital-firms-improves-but-more-ground-to-cover/2448228/",
    type: "link",
  },
  {
    id: 5,
    pname: "Pehal News",
    title: "Here's how venture capital firms can reduce the gender gap in investing",
    bimg: pehal,
    date: "March 2022 | Press Coverage",
    link:
      "https://www.pehalnews.in/heres-how-venture-capital-firms-can-reduce-the-gender-gap-in-investing/1685592/",
    type: "link",
  },
  {
    id: 5,
    pname: "The Economic Times",
    title: "Budget 2022: Women entrepreneurs want digital divide, finance gap to be bridged",
    bimg: et,
    date: "January 2022 | Press Coverage",
    link:
      "https://economictimes.indiatimes.com/small-biz/entrepreneurship/budget-2022-women-entrepreneurs-want-digital-divide-finance-gap-to-be-bridged/videoshow/88917748.cms?utm_source=twitter.com&utm_medium=Social&utm_campaign=ETTWRISE",
    type: "link",
  },
  {
    id: 5,
    pname: "The Economic Times",
    title: "Closing the gender gap in financing: Basic business friendly tools that can be adopted across the corporate world",
    bimg: et,
    date: "January 2022 | Press Coverage",
    link:
      "https://economictimes.indiatimes.com/small-biz/entrepreneurship/closing-the-gender-gap-in-financing-basic-business-friendly-tools-that-can-be-adopted-across-the-corporate-world/articleshow/88680331.cms?from=mdr",
    type: "link",
  },
  {
    id: 5,
    pname: "Bloomberg",
    title:
      "Winpe's Garg on Gender Diversity",
    bimg: bloomberg,
    date: "December 2021 | Press Coverage",
    link:
      "https://www.bloomberg.com/news/videos/2021-12-15/winpe-s-garg-on-gender-diversity-video",
    type: "link",
  },
  {
    id: 5,
    pname: "VCCiRCLE",
    title:
      "Indian AIFs, Limited Partners, wary of SEBI request for co-investment information      ",
    bimg: vccircle,
    date: "September 2021 | Press Coverage",
    link:
      "https://www.vccircle.com/indian-aifs-limited-partners-wary-of-sebi-request-for-co-investment-information",
    type: "link",
  },
  {
    id: 5,
    pname: "Private Equity International",
    title:
      "Meet the ex-IFC vet on a mission to improve PE’s gender diversity",
    bimg: pe,
    date: "August 2021 | Press Coverage",
    link:
      "https://www.privateequityinternational.com/meet-the-ex-ifc-vet-on-a-mission-to-improve-pes-gender-diversity/",
    type: "link",
  },
  {
    id: 5,
    pname: "VCCiRCLE",
    title:
      "The fine line between regulation and over-regulation",
    bimg: vccircle,
    date: "July 2021 | Press Coverage",
    link:
      "https://www.vccircle.com/the-fine-line-between-regulation-and-over-regulation",
    type: "link",
  },
  {
    id: 5,
    pname: "Your Story",
    title:
      "This woman's not-for-profit aims to transform the investing world in favour of gender diversity",
    bimg: yourstorynupur,
    date: "May 2021 | Press Coverage",
    link:
      "https://yourstory.com/herstory/2021/05/woman-entrepreneur-not-for-profit-investment-gender-diversity/",
    type: "link",
  },
  {
    id: 5,
    pname: "Fortune India",
    title:
      "Responsible investing: Old concept, modern usage ",
    bimg: fortune,
    date: "May 2021 | Opinion",
    link:
      "https://www.fortuneindia.com/opinion/responsible-investing-ancient-concept-modern-usage/105466",
    type: "link",
  },
  {
    id: 5,
    pname: "Business World | BW Education",
    title:
      "Through The Eyes Of A 'Diversity Candidate'",
    bimg: bweducation,
    date: "May 2021 | Article",
    link:
      "http://bweducation.businessworld.in/article/Through-The-Eyes-Of-A-Diversity-Candidate-/06-05-2021-388853/",
    type: "link",
  },
  {
    id: 5,
    pname: "Business News This Week",
    title:
      "Investcorp India partners with Winpe for advancing gender diversity",
    bimg: businessnewsthisweek,
    date: "March 2021 | Press Coverage",
    link:
      "http://businessnewsthisweek.com/business/investcorp-india-partners-with-winpe-for-advancing-gender-diversity/",
    type: "link",
  },
  {
    id: 5,
    pname: "AsiaOne & CNBC TV 18",
    title: "Greatest Brands & Leaders Asia & GCC 2020-21",
    bimg: asiaone,
    date: "March 2021 | Segment Broadcast",
    link: "https://www.youtube.com/watch?v=hBr5DlVpL6g",
    type: "video",
  },
  {
    id: 5,
    pname: "IVCA 2021",
    title:
      "Renuka Ramnath in conversation with Keynote Speaker Shri Piyush Goyal, Hon’ble Minister Of Commerce & Industry",
    bimg: ivca,
    date: "March 2021 | Mention",
    link: "https://www.youtube.com/watch?v=qtOcDZD25ks",
    type: "video",
  },
  {
    id: 5,
    pname: "TechGraph",
    title:
      "Leading Indian & Global Investors adopt Winpe's Charter For Gender Diversity",
    bimg: techgraph,
    date: "March 2021 | Press Coverage",
    link:
      "https://techgraph.co/inside/leading-indian-global-investors-adopt-winpes-charter-gender-diversity/",
    type: "link",
  },
  {
    id: 5,
    pname: "IBTN9",
    title: "Winpe’s charter for gender diversity ahead of Women’s Day",
    bimg: ibtn9,
    date: "March 2021 | Press Coverage",
    link:
      "https://ibtn9.com/2021/03/winpes-charter-for-gender-diversity-ahead-of-womens-day/",
    type: "link",
  },

  {
    id: 5,
    pname: "Moneycontrol",
    title:
      "For women investors, too, raw deal is a reality in the Indian startup ecosystem",
    bimg: moneycontrol,
    date: "March 2021 | Press Coverage",
    link:
      "https://www.moneycontrol.com/news/business/startup/for-women-investors-too-raw-deal-is-a-reality-in-the-indian-startup-ecosystem-6617651.html",
    type: "link",
  },
  {
    id: 5,
    pname: "The Economic Times",
    title: "The missed opportunity with diverse boards",
    bimg: imgUrlET,
    date: "March 2021 | Opinion Piece",
    link:
      "https://economictimes.indiatimes.com/small-biz/hr-leadership/leadership/the-missed-opportunity-with-diverse-boards/articleshow/81360814.cms",
    type: "link",
  },
  {
    id: 5,
    pname: "Moneycontrol",
    title:
      "Gender bias, mansplaining and lack of diversity exist but are defeatable evils in the start up ecosystem, say leading investors",
    bimg: moneycontrol,
    date: "March 2021 | Podcast",
    link:
      "https://www.moneycontrol.com/news/podcast/setting-sail-podcast-womens-day-2021-gender-bias-mansplaining-and-lack-of-diversity-exist-but-are-defeatable-evils-in-the-start-up-ecosystem-say-leading-investors-6606961.html",
    type: "link",
  },
  {
    id: 5,
    pname: "The Economic Times",
    title:
      "The tightrope walk between diversity quotas and being forward leaning",
    bimg: imgUrlET,
    date: "February 2021 | Opinion Piece",
    link:
      "https://economictimes.indiatimes.com/small-biz/hr-leadership/people/the-tightrope-walk-between-diversity-quotas-and-being-forward-leaning/articleshow/80718402.cms",
    type: "link",
  },

  {
    id: 5,
    pname: "Financial Express",
    title: "Celebrating successful women or undermining them",
    bimg: imgUrlFE,
    date: "January 2021 | Opinion Piece",
    link:
      "https://www.financialexpress.com/industry/sme/cafe-sme/we-are-long-way-from-a-place-where-enough-women-will-be-in-workplace-for-gender-diversity-to-be-obsolete/2173066/",
    type: "link",
  },
  {
    id: 5,
    pname: "Business Standard",
    title:
      "Russell Reynolds Associates and Winpe launch pioneering mentorship program for women in investing",
    bimg: imgUrl8,
    date: "October 2020 | Press Coverage",
    link:
      "https://www.business-standard.com/content/press-releases-ani/russell-reynolds-associates-and-winpe-launch-pioneering-mentorship-program-for-women-in-investing-120100500643_1.html",
    type: "link",
  },
  {
    id: 4,
    pname: "Forbes India",
    title: "Forbes India W-Power: Self Made Women 2020",
    bimg: imgUrl3,
    date: "March 2020 | Press Coverage",
    link: "https://www.forbesindia.com/lists/self-made-women-2020/1835/1",
    type: "link",
  },
  {
    id: 5,
    pname: "Business World",
    title:
      "Russell Reynolds Associates and Winpe launch pioneering mentorship program for women in investing",
    bimg: imgUrl9,
    date: "October 2020 | Press Coverage",
    link:
      "http://www.businessworld.in/article/Russell-Reynolds-Associates-and-WinPE-launch-pioneering-mentorship-program-for-women-in-investing/05-10-2020-328032/",
    type: "link",
  },
  {
    id: 2,
    pname: "Forbes India",
    title: "Invested in Private Equity",
    bimg: imgUrl3,
    date: "March 2020 | Press Coverage",
    link: "https://winpeforum.com/assets/elements/nupur_garg_artical1.jpg",
    type: "link",
  },
  {
    id: 5,
    pname: "The Week",
    title:
      "Russell Reynolds Associates and Winpe launch pioneering mentorship program for women in investing",
    bimg: imgUrl11,
    date: "October 2020 | Press Coverage",
    link:
      "https://www.theweek.in/wire-updates/business/2020/10/05/pwr11-russell-reynolds-associates.html",
    type: "link",
  },
  {
    id: 3,
    pname: "Livemint",
    title: "Breaking Societal Norms: Diversity in the Investing Ecosystem",
    bimg: imgUrl4,
    date: "March 2020 | Press Coverage",
    link:
      "https://www.livemint.com/videos/society-holding-women-back-nupur-garg-founder-winpe-11583570521438.html",
    type: "link",
  },
  {
    id: 5,
    pname: "Outlook India",
    title:
      "Russell Reynolds Associates and Winpe launch pioneering mentorship program for women in investing",
    bimg: imgUrl10,
    date: "October 2020 | Press Coverage",
    link:
      "https://www.outlookindia.com/newsscroll/russell-reynolds-associates-and-winpe-launch-pioneering-mentorship-program-for-women-in-investing/1949040",
    type: "link",
  },
  {
    id: 1,
    pname: "The Economic Times",
    title: "To break boys club in Indian PE, women join hands",
    bimg: imgUrl2,
    date: "February 2020 | Press Coverage",
    link:
      "https://economictimes.indiatimes.com/news/company/corporate-trends/to-break-boys-club-in-indian-pe-women-join-hands/articleshow/74248883.cms",
    type: "link",
  },
];

const knowledgeResources = [
     {
    id: 21,
    title: `<div>Former IFC exec-backed Winpe eyes fund to invest in women-led startups</div>`,
    auto: "Deal Street Asia",
    date: "May 2026 | Article",
    type: "article",
    listlink:
      "https://www.dealstreetasia.com/stories/winpe-maiden-fund-482034",
    sdata: "Nupur Garg",
  },   
   {
    id: 21,
    title: `<div>Where merit and accommodation collide</div>`,
    auto: "Hindustan Times",
    date: "May 2026 | Article",
    type: "article",
    listlink:
      "https://www.hindustantimes.com/ht-insight/economy/where-merit-and-accommodation-collide-101777805540949.html",
    sdata: "Nupur Garg",
  },
  {
    id: 21,
    title: `<div>Entrepreneurship Is Still a Boys’ Club</div>`,
    auto: "Anoushka Menezes & Kyra Menezes",
    date: "Sep 2024 | Contributor Spotlight",
    type: "contributor spotlight",
    listlink:
      "/Entrepreneurship-Is-Still-a-Boys-Club/",
    sdata: "Anoushka Menezes & Kyra Menezes",
  },
  {
    id: 21,
    title: `<div>Does it ‘look difficult’ or should I just say ‘no’? </div>`,
    auto: "Kyati Parekh of General Counsel",
    date: "July 2024 | Contributor Spotlight",
    type: "contributor spotlight",
    listlink:
      "/Does-it-look-difficult-or-should-I-just-say-no/",
    sdata: "Kyati Parekh of General Counsel",
  },
  {
    id: 21,
    title: `<div>India Private Equity Report 2023</div>`,
    auto: "Bain & Company",
    date: "April 2023 | Report",
    type: "report",
    listlink:
      "https://www.bain.com/insights/india-private-equity-report-2023/",
    sdata: "India Private Equity Report 2022",
  },
  {
    id: 21,
    title: `<div> Why Gender Lens Investing May Lead to Better Returns</div>`,
    auto: "Morgan Stanley",
    date: "February 2023 | Article",
    type: "article",
    listlink:
      "http://www.primeinfobase.com/indianboards/files/IIM_Ahmedabad_FICCI_PRIME_WOB_report.pdf",
    sdata: " Why Gender Lens Investing May Lead to Better Returns",
  },
  {
    id: 21,
    title: `<div>Corporate India Women on Boards</div>`,
    auto: "Institutional Investor Advisory Services",
    date: "November 2022 | Report",
    type: "report",
    listlink:
      "https://iias-cms.s3.ap-south-1.amazonaws.com/F2_1_Corporate_India_Women_on_Boards_Nov_2022_19912556cb.pdf",
    sdata: "Corporate India Women on Boards",
  },
  {
    id: 21,
    title: `<div>India Private Equity Report 2022</div>`,
    auto: "Bain & Company",
    date: "June 2022 | Report",
    type: "report",
    listlink:
      "https://www.bain.com/insights/india-private-equity-report-2022/",
    sdata: "India Private Equity Report 2022",
  },
  
  
  
 
  {
    id: 21,
    title: `<div>Closing the Gender Gap in Investing – how Indian PE/VC firms can bridge the diversity divide</div>`,
    auto: "Winpe-BCG",
    date: "March 2022 | Report",
    type: "report",
    listlink:
      "https://winpeforum.com/assets/docs/Women-in-PE-V6-For-Distribution.pdf",
    sdata: "Closing the Gender Gap in Investing",
  },
  {
    id: 21,
    title: `<div>Women in the Boardroom</div>`,
    auto: "Delloite",
    date: "February 2022 | Report",
    type: "report",
    listlink:
      "https://www.deloitte.com/global/en/services/risk-advisory/research/women-in-the-boardroom-seventh-edition.html",
    sdata: "Women in the Boardroom",
  },
  {
    id: 21,
    title: `<div>2022 Bloomberg Gender-Equality Index </div>`,
    auto: "Bloomberg",
    date: "January 2022 | Report",
    type: "report",
    listlink:
      "https://assets.bbhub.io/company/sites/46/2021/01/992304_GEI_Booklet_FNL.pdf",
    sdata: "2022 Bloomberg Gender-Equality Index",
  },
  {
    id: 21,
    title: `<div>2022 Bloomberg Gender-Equality Index Data Sheet</div>`,
    auto: "Bloomberg",
    date: "January 2022 | Report",
    type: "report",
    listlink:
      "https://assets.bbhub.io/company/sites/46/2021/01/Bloomberg_GEI_DataSheet.pdf",
    sdata: "2022 Bloomberg Gender-Equality Index Data Sheet",
  },
  {
    id: 21,
    title: `<div>Project 4.0: Tracking Venture Capital, Private Equity, and Private Debt with a Gender Lens </div>`,
    auto: "Wharton Social Impact Initiative",
    date: "December 2021 | Report",
    type: "report",
    listlink:
      "https://socialimpact.wharton.upenn.edu/research-reports/reports-2/project-sage-4/",
    sdata: "Project 4.0: Tracking Venture Capital, Private Equity, and Private Debt with a Gender Lens",
  },
  {
    id: 21,
    title: `<div>How Private Equity Can Catch Up on Diversity    </div>`,
    auto: "BCG",
    date: "June 2021 | Report",
    type: "report",
    listlink:
      "https://www.bcg.com/en-in/publications/2021/how-pe-owned-companies-can-catch-up-on-diversity",
    sdata: "How Private Equity Can Catch Up on Diversity",
  },
  {
    id: 21,
    title: `<div>India Private Equity Report 2021</div>`,
    auto: "IVCA | Bain & Company, Inc.",
    date: "June 2021 | Report",
    type: "report",
    listlink:
      "https://winpeforum.com/assets/docs/bain_report_india_private_equity_report_2021.pdf",
    sdata: "India Private Equity Report 2021",
  },
  
  {
    id: 21,
    title: `<div>Nupur Garg</div>`,
    auto: "Asiaone",
    date: "April 2021 | Article",
    type: "report",
    listlink:
      "https://asiaone.co.in/nupur-garg/#:~:text=Nupur%20is%20a%20Chartered%20Accountant,decade%20by%20her%20thesis%20advisor",
    sdata: "",
  },
  {
    id: 21,
    title: `<div>Preqin Impact Report: Women in Alternative Assets</div>`,
    auto: "Preqin",
    date: "March 2021 | Report",
    type: "report",
    listlink:
      "https://go.preqin.com/hubfs/Preqin-Impact-Report-Women-in-Alternative-Assets-March-2021-1.pdf?hsCtaTracking=ced380e8-c792-47a2-8eae-bf27ed732275%7C89c833dc-034a-4287-9387-910c1f62d441",
    sdata: "Preqin Impact Report: Women in Alternative Assets",
  },
  {
    id: 21,
    title: `<div>Balanced Recruitment Outcomes</div>`,
    auto: "A91 Partners",
    date: "February 2021 | Case Study",
    type: "case studies",
    listlink: "https://winpeforum.com/assets/docs/A91-case-study.pdf",
    sdata: "Balanced Recruitment Outcomes case studies study A91 Partners",
  },

  {
    id: 21,
    title: `<div>Driving the Top Down Agenda</div>`,
    auto: "AZB & Partners",
    date: "February 2021 | Case Study",
    type: "case studies",
    listlink:
      "https://winpeforum.com/assets/docs/AZB-Case-Study-Best-Practices.pdf",
    sdata: "Driving the Top Down Agenda AZB & Partners case studies study",
  },
  {
    id: 21,
    title: `<div>Expanding the Sphere of Influence</div>`,
    auto: "CDPQ",
    date: "February 2021 | Case Study",
    type: "case studies",
    listlink:
      "https://winpeforum.com/assets/docs/Diversity_CDPQ_case_study.pdf",
    sdata: "Expanding the Sphere of Influence CDPQ case studies study",
  },
  {
    id: 21,
    title: `<div>Adopting a Multi-Pronged Approach</div>`,
    auto: "Trilegal",
    date: "February 2021 | Case Study",
    type: "case studies",
    listlink: "https://winpeforum.com/assets/docs/Trilegal-Case-Study.pdf",
    sdata: "Adopting a Multi-Pronged Approach Trilegal case studies study",
  },
  {
    id: 21,
    title: `<div>The Mastercard Index of Women Entrepreneurs 2020
    </div>`,
    auto: "Mastercard ",
    date: "November 2020 | Report ",
    type: "report",
    listlink:
      "https://winpeforum.com/assets/docs/TheMastercardIndexofWomenEntrepreneurs2020.pdf",
    sdata: "The Mastercard Index of Women Entrepreneurs 2020",
  },
  {
    id: 21,
    title: `<div>Why Private Equity Firms Should Include More Women
    </div>`,
    auto: "HEC Paris",
    date: "October 2020 | Case Study ",
    type: "report",
    listlink:
      "https://www.hec.edu/en/knowledge/instants/why-private-equity-firms-should-include-more-women",
    sdata: "Women in the Workplace September 2020 Report McKinsey & Company",
  },
  {
    id: 21,
    title: `<div>Women in the Workplace</div>`,
    auto: "McKinsey & Company",
    date: "September 2020 | Report ",
    type: "report",
    listlink:
      "https://wiw-report.s3.amazonaws.com/Women_in_the_Workplace_2020.pdf",
    sdata: "Women in the Workplace September 2020 Report McKinsey & Company",
  },
  {
    id: 21,
    title: `<div>Project 3.0: Tracking Venture Capital, Private Equity and Private Debt with a Gender Lens</div>`,
    auto: "Wharton Social Impact Initiative & Catalyst at Large",
    date: "July 2020 | Report",
    type: "report",
    listlink:
      "https://www.wharton.upenn.edu/story/project-sage-3-0-key-insights-from-the-latest-gender-lens-investing-report/",
    sdata:
      "Project 3.0: Tracking Venture Capital, Private Equity and Private Debt with a Gender Lens Wharton Social Impact Initiative & Catalyst at Large July 2020 Report ",
  },
  {
    id: 21,
    title: `<div>Women as the next wave of growth in US wealth management</div>`,
    auto: "McKinsey & Company ",
    date: "July 2020 | Article ",
    type: "article",
    listlink:
      "https://www.mckinsey.com/industries/financial-services/our-insights/women-as-the-next-wave-of-growth-in-us-wealth-management?cid=other-eml-alt-mip-mck&hlkid=14c2664870c34eacbf8be8fcec07f9ef&hctky=2075301&hdpid=7b51bf4d-abb2-45bd-8a76-8eb6bd46984a",
    sdata:
      "Women as the next wave of growth in US wealth management McKinsey & Company  July 2020 Article ",
  },
  {
    id: 21,
    title: `<div>More women hired at VC funds but not enough decision-makers</div>`,
    auto: "ET Tech ",
    type: "article",
    date: "July 2020 | Article ",
    listlink:
      "https://tech.economictimes.indiatimes.com/news/people/more-women-venture-into-vc-investment-space/77161344",
    sdata:
      "More women hired at VC funds but not enough decision-makers ET Tech  July 2020 Article ",
  },
  {
    id: 21,
    title: `<div>Finance’s Gender Gap Widens as Female Applicants to Top Jobs Dip</div>`,
    auto: "Bloomberg",
    date: "July 2020 | Article ",
    type: "article",
    listlink:
      "https://www.bloomberg.com/news/articles/2020-07-26/finance-s-gender-gap-widens-as-female-applicants-to-top-jobs-dip",
    sdata:
      "Finance’s Gender Gap Widens as Female Applicants to Top Jobs Dip Bloomberg  July 2020 Article ",
  },
  {
    id: 21,
    title: `<div>Firms with more female executives 'perform better'</div>`,
    auto: "BBC News ",
    type: "article",
    date: "July 2020 | Article ",
    listlink: "https://www.bbc.com/news/business-53548704",
    sdata:
      "Firms with more female executives perform better BBC News   July 2020 Article ",
  },
   
  {
    id: 21,
    title: `<div>Women on Boards in India</div>`,
    auto: "Bain & Company",
    date: "June 2020 | Report",
    type: "report",
    listlink:
      "http://www.primeinfobase.com/indianboards/files/IIM_Ahmedabad_FICCI_PRIME_WOB_report.pdf",
    sdata: "Women on Boards in India",
  },
  
  {
    id: 21,
    title: `<div>Women on Boards in India</div>`,
    auto: "IIM Ahmedabad & FICCI ",
    type: "report",
    date: "June 2020 | Report ",
    listlink: "https://www.winpeforum.com/assets/docs/WOB_Final-Report_3103_V12_Final.pdf",
    sdata: "June 2020 Report IIM Ahmedabad & FICCI Women on Boards in India",
  },
  {
    id: 21,
    title: `<div>Understanding organizational barriers to a more inclusive workplace</div>`,
    auto: "McKinsey & Company",
    date: "June 2020 | Survey",
    type: "survey",
    listlink:
      "https://www.mckinsey.com/business-functions/organization/our-insights/understanding-organizational-barriers-to-a-more-inclusive-workplace",
    sdata:
      "Understanding organizational barriers to a more inclusive workplace McKinsey & Company June 2020 Survey",
  },
  {
    id: 21,
    title: `<div>Diversity and Inclusion Efforts That Really Work</div>`,
    auto: "Harvard Business Review",
    date: "May 2020 | Article",
    type: "article",
    listlink:
      "https://hbr.org/2020/05/diversity-and-inclusion-efforts-that-really-work",
    sdata:
      "Diversity and Inclusion Efforts That Really Work Harvard Business Review May 2020 Article",
  },
  {
    id: 20,
    title: `<div>Why the Crisis Is Putting Companies at Risk of Losing Female Talent</div>`,
    auto: "Harvard Business Review",
    date: "May 2020 | Article",
    type: "article",
    listlink:
      "https://hbr.org/2020/05/why-the-crisis-is-putting-companies-at-risk-of-losing-female-talent",
    sdata:
      "Why the Crisis Is Putting Companies at Risk of Losing Female Talent Harvard Business Review May 2020 Article",
  },
  {
    id: 12,
    title: `<div>Diversity Wins: How Inclusion Matters</div>`,
    auto: "McKinsey & Company",
    date: "May 2020 | Report",
    type: "report",
    listlink:
      "https://www.mckinsey.com/~/media/McKinsey/Featured%20Insights/Diversity%20and%20Inclusion/Diversity%20wins%20How%20inclusion%20matters/Diversity-wins-How-inclusion-matters-vF.ashx",
    sdata:
      "Diversity Wins: How Inclusion Matters McKinsey & Company May 2020 Report",
  },
  {
    id: 13,
    title: `<div>From thinking about the next normal to making it work: What to stop, start, and accelerate</div>`,
    auto: "McKinsey & Company",
    date: "May 2020 | Article",
    type: "article",
    listlink:
      "https://www.mckinsey.com/featured-insights/leadership/from-thinking-about-the-next-normal-to-making-it-work-what-to-stop-start-and-accelerate",
    sdata:
      "From thinking about the next normal to making it work: What to stop, start, and accelerate McKinsey & Company May 2020 Article",
  },
  {
    id: 14,
    title: `<div>Diversity Still Matters</div>`,
    auto: "McKinsey & Company",
    date: "May 2020 | Article",
    type: "article",
    listlink:
      "https://www.mckinsey.com/featured-insights/diversity-and-inclusion/diversity-still-matters?cid=other-eml-alt-mcq-mck&hlkid=a6a0fba9d7cd43b1a8fd7d3b6584b0e2&hctky=2075301&hdpid=52326651-ffed-42b0-a071-c4da1d6db283",
    sdata: "Diversity Still Matters McKinsey & Company May 2020 | Article",
  },
  {
    id: 15,
    title: `<div>Adapt Your D&I Efforts to the Reality of the Crisis</div>`,
    auto: "Harvard Business Review",
    date: "May 2020 | Article",
    type: "article",
    listlink:
      "https://hbr.org/2020/05/adapt-your-di-efforts-to-the-reality-of-the-crisis",
    sdata:
      "Adapt Your D&I Efforts to the Reality of the Crisis Harvard Business Review May 2020 Article",
  },
  {
    id: 15,
    title: `<div>How Are Mothers And Fathers Balancing Work And Family Under Lockdown?</div>`,
    auto: "Institute for Fiscal Studies",
    date: "May 2020 | Report ",
    type: "report",
    listlink:
      "https://www.ifs.org.uk/uploads/BN290-Mothers-and-fathers-balancing-work-and-life-under-lockdown.pdf",
    sdata:
      "Institute for Fiscal Studies May 2020 Report How Are Mothers And Fathers Balancing Work And Family Under Lockdown?",
  },
  {
    id: 15,
    title: `<div>We Cannot Allow COVID-19 To Reinforce The Digital Gender Divide</div>`,
    auto: "UN Women",
    type: "article",
    date: "May  2020 | Article",
    listlink:
      "https://www.unwomen.org/en/news/stories/2020/5/op-ed-ed-phumzile-covid-19-and-the-digital-gender-divide",
    sdata:
      "UN Women May  2020 Article We Cannot Allow COVID-19 To Reinforce The Digital Gender Divide ",
  },
  {
    id: 15,
    title: `<div>Easing The COVID-19 Burden On Working Parents </div>`,
    auto: "Boston Consulting Group",
    type: "article",
    date: "May 2020 | Article",
    listlink:
      "https://www.bcg.com/publications/2020/helping-working-parents-ease-the-burden-of-covid-19.aspx",
    sdata:
      "Boston Consulting Group May  2020 Article Easing The COVID-19 Burden On Working Parents  ",
  },
  {
    id: 16,
    title: `<div>7 Leadership Lessons Men Can Learn From Women</div>`,
    auto: "Harvard Business Review",
    type: "article",
    date: "April 2020 | Article",
    listlink:
      "https://hbr.org/2020/04/7-leadership-lessons-men-can-learn-from-women",
    sdata:
      "7 Leadership Lessons Men Can Learn From Women April 2020 Article Harvard Business Review",
  },
  {
    id: 16,
    title: `<div>How to Be an Inclusive Leader Through a Crisis</div>`,
    auto: "Harvard Business Review",
    type: "article",
    date: "April 2020 | Article",
    listlink:
      "https://hbr.org/2020/04/how-to-be-an-inclusive-leader-through-a-crisis#:~:text=Begin%20meetings%20with%20acknowledging%20everyone,their%20own%20challenges%20or%20vulnerabilities.",
    sdata:
      "How to Be an Inclusive Leader Through a Crisis Harvard Business Review April 2020 Article",
  },
  {
    id: 17,
    title: `<div>Practicing Inclusive Leadership in Times of Crisis 2020</div>`,
    auto: "Deloitte",
    type: "article",
    date: "April 2020 | Article",
    listlink:
      "https://www2.deloitte.com/content/dam/Deloitte/global/Documents/About-Deloitte/gx-thrive-tal-start-employee-education-training-in-crisispdf2.pdf",
    sdata:
      "Practicing Inclusive Leadership in Times of Crisis 2020 Deloitte April 2020 Article",
  },
  {
    id: 17,
    title: `<div>5 Changes To Expect In The Workplace After COVID-19</div>`,
    auto: "Fast Company",
    type: "article",
    date: "April 2020 | Article",
    listlink:
      "https://www.fastcompany.com/90496811/5-changes-to-expect-in-the-workplace-after-covid-19",
    sdata:
      "5 Changes To Expect In The Workplace After COVID-19 Fast Company April 2020 Article",
  },
  {
    id: 18,
    title: `<div>The Face Of Angel Investing Is Changing. Here’s What You Need To Know</div>`,
    auto: "Forbes",
    type: "article",
    date: "March 2020 | Article",
    listlink:
      "https://www.forbes.com/sites/jiawertz/2020/03/31/face-angel-investing-changing-what-you-need-to-know/#6a8eb35b6ba3",
    sdata:
      "The Face Of Angel Investing Is Changing. Here’s What You Need To Know Forbes March 2020 Article",
  },
  {
    id: 18,
    title: `<div>The Key to Inclusive Leadership</div>`,
    auto: "Harvard Business Review",
    type: "article",
    date: "March 2020 | Article ",
    listlink: "https://hbr.org/2020/03/the-key-to-inclusive-leadership",
    sdata:
      "The Key to Inclusive Leadership Harvard Business Review March 2020 Article",
  },
  {
    id: 0,
    title: `<div>Where Are All the Women CEOs?</div>`,
    auto: "The Wall Street Journal",
    type: "article",
    date: "February 2020 | Article",
    listlink:
      "https://www.wsj.com/articles/why-so-few-ceos-are-women-you-can-have-a-seat-at-the-table-and-not-be-a-player-11581003276",
    sdata:
      "Where Are All the Women CEOs?  The Wall Street Journal February 2020 Article",
  },
  {
    id: 0,
    title: `<div>Preqin Impact Report: Women in Alternative Assets</div>`,
    auto: "Preqin",
    type: "report",
    date: "February 2020 | Report",
    listlink:
      "https://go.preqin.com/women-in-alternative-assets-feb-2020?utm_campaign=Women%20in%20Alternatives%202020&utm_medium=email&_hsenc=p2ANqtz--0XoHn9EOEXzuQy5fiKxNdS4qGOQ7iia2jWGf_2MEc-iTpWb0e3MmmDymSjXotBmmWXqyWOvd_lWANsKwBxWxLeOXRjW6mrMmH17zl6Emq4rVwfxo&_hsmi=83930708&utm_source=hs_email&utm_content=83926832&hsCtaTracking=4863fba5-01ce-432d-b65f-c7bf354cf58e%7Cc7c10804-621a-47f0-97e5-4a67814e8040",
    sdata:
      "Preqin Impact Report: Women in Alternative Assets Preqin February 2020 Repor",
  },
  {
    id: 1,
    title: `<div>Gender Diversity and M&A Outcomes:<br /> How Female Board-Level Representation Affects Corporate Dealmaking</div>`,
    auto: " SS&C Intralinks, Cass Business School, London and Acuris Studios.",
    date: "February 2020 | Report",
    type: "report",
    listlink:
      "https://www.intralinks.com/insights/publication/gender-diversity-ma-outcomes?utm_source=marketo&utm_medium=email&utm_campaign=7011y0000024uoz&utm_content=e1&mkt_tok=eyJpIjoiWVRFNE5qYzBZak0wTURVMSIsInQiOiJNdGVVbjNlUWlyS0VlMlc4MjRHWVhHUE5hNUFrdVNtRkpcL05pWWxLaGxaV2FBZGhqWFFnNmJjT2crb1lvdmM0VlVoaHQ5YjVTSnl2Y2xwYnR1SjlxbFhFbXdMaDJGcmxVZ0RzSkNUSWdNc1p6Z3hrZU9GcWFQZzlmcmJhVE9zM2EifQ%3D%3D",
    sdata:
      "Gender Diversity and M&A Outcomes: How Female Board-Level Representation Affects Corporate Dealmaking SS&C Intralinks, Cass Business School, London and Acuris Studios February 2020 Report",
  },
  {
    id: 1,
    title: `<div>Confronting the early-career gender gap</div>`,
    auto: "McKinsey & Company",
    date: "January 2020 | Article",
    type: "article",
    listlink:
      "https://www.mckinsey.com/business-functions/organization/our-insights/confronting-the-early-career-gender-gap",
    sdata:
      "Confronting the early-career gender gap McKinsey & Company January 2020 Article",
  },
  {
    id: 2,
    title: "New Voices Media Training Program",
    auto: "Bloomberg",
    date: "December 2019 | Program",
    type: "program",
    listlink:
      "https://www.bloomberg.com/women/new-voices-media-training-program/",
    sdata: "New Voices Media Training Program Bloomberg December 2019 Program",
  },
  {
    id: 3,
    title: "No Place for Women Entrepreneurs?",
    auto: "Financial Express",
    date: "December 2019 | Article",
    type: "article",
    listlink:
      "https://www.financialexpress.com/industry/sme/cafe-sme/msme-other-no-place-for-women-entrepreneurs-why-investors-have-a-problem-with-women-led-businesses/1802832/",
    sdata:
      "No Place for Women Entrepreneurs Financial Express December 2019 Article",
  },
  {
    id: 2,
    title: "When women lead, workplaces should listen",
    auto: "McKinsey & Company",
    date: "December 2019 | Article",
    type: "article",
    listlink:
      "https://www.mckinsey.com/featured-insights/leadership/when-women-lead-workplaces-should-listen",
    sdata:
      "When women lead, workplaces should listen McKinsey & Company December 2019 Article",
  },
  {
    id: 2,
    title: "Taking the lead for inclusion",
    auto: "McKinsey & Company",
    date: "November 2019 | Article",
    type: "article",
    listlink:
      "https://www.mckinsey.com/featured-insights/gender-equality/taking-the-lead-for-inclusion",
    sdata:
      "Taking the lead for inclusion McKinsey & Company November 2019 Article",
  },
  {
    id: 4,
    title: "The Way We Lead",
    auto: "Rohei Consulting",
    date: "October 2019 | Report",
    type: "report",
    listlink: "https://www.rohei.com/the-way-we-lead-report",
    sdata: "The Way We Lead Rohei Consulting October 2019 Report",
  },
  {
    id: 4,
    title: "Women in the Workplace",
    auto: "McKinsey & Company",
    date: "October 2019 | Article",
    type: "article",
    listlink:
      "https://wiw-report.s3.amazonaws.com/Women_in_the_Workplace_2019.pdf",
    sdata: "Women in the Workplace McKinsey & Company October 2019 Article",
  },
  {
    id: 4,
    title: "Women Matter: Ten years of insights on gender diversity",
    auto: "McKinsey & Company",
    date: "October 2019 | Article",
    type: "article",
    listlink:
      "https://www.mckinsey.com/featured-insights/gender-equality/women-matter-ten-years-of-insights-on-gender-diversity",
    sdata:
      "Women Matter: Ten years of insights on gender diversity McKinsey & Company October 2019 Article",
  },
  {
    id: 4,
    title: "The diversity opportunity for new CEOs",
    auto: "McKinsey & Company",
    date: "August 2019 | Podcast",
    type: "podcast",
    listlink:
      "https://www.mckinsey.com/business-functions/strategy-and-corporate-finance/our-insights/the-diversity-opportunity-for-new-ceos",
    sdata:
      "The diversity opportunity for new CEOs McKinsey & Company August 2019 Podcast",
  },
  {
    id: 5,
    title: "Gender diversity increases performance and IRR",
    auto: "HEC Paris, MVision, Private Equity Advisers",
    type: "report",
    date: "July 2019 | Report",
    listlink:
      "https://www.privateequityinternational.com/gender-diversity-increases-performance-irr/",
    sdata:
      "Gender diversity increases performance and IRR HEC Paris, MVision Private Equity Advisers July 2019 Report",
  },
  {
    id: 5,
    title: "Women in Limited Partners",
    auto: "BVCA and Level20",
    type: "report",
    date: "June 2019 | Report",
    listlink:
      "https://www.level20.org/wp-content/uploads/2019/07/Women-in-LP-Report-2019.pdf",
    sdata: "June 2019 Report",
  },
  {
    id: 6,
    title: "Moving toward gender balance in private equity and venture capital",
    auto: "IFC, Oliver Wyman, RockCreek",
    type: "report",
    date: "March 2019 | Report",
    listlink:
      "https://www.ifc.org/wps/wcm/connect/79e641c9-824f-4bd8-9f1c-00579862fed3/Moving+Toward+Gender+Balance+Final_3_22.pdf?MOD=AJPERES&CVID=mCBJFra",
    sdata:
      "Moving toward gender balance in private equity and venture capital IFC, Oliver Wyman, RockCreek March 2019 Report",
  },
  {
    id: 18,
    title: `<div>At only 3%, Corporate India is still struggling to bring women to the top</div>`,
    auto: "The Economic Times",
    date: "March 2019 | Article",
    type: "article",
    listlink:
      "https://economictimes.indiatimes.com/news/company/corporate-trends/at-only-3-corporate-india-is-still-struggling-to-bring-women-to-the-top/articleshow/68589499.cms?utm_source=contentofinterest&utm_medium=text&utm_campaign=cppst",
    sdata:
      "At only 3%, Corporate India is still strugglingto bring women to the top The Economic Times March 2019 Article",
  },
  {
    id: 19,
    title: "Research: When Gender Diversity Makes Firms More Productive",
    auto: "Harvard Business Review",
    date: "February 2019 | Article",
    type: "article",
    listlink:
      "https://hbr.org/2019/02/research-when-gender-diversity-makes-firms-more-productive",
    sdata:
      "Research: When Gender Diversity Makes Firms More Productive Harvard Business Review February 2019 Article",
  },
  {
    id: 7,
    title: "Moving toward gender balance in private equity and venture capital",
    auto: "IFC, Oliver Wyman, RockCreek",
    type: "research",
    date: "February 2019 | Research",
    listlink:
      "https://www.oliverwyman.com/content/dam/oliver-wyman/Brazil/Research-Findings-Women-in-PE-in-EM.pdf",
    sdata:
      "Moving toward gender balance in private equity and venture capital IFC, Oliver Wyman, RockCreek February 2019 Research",
  },
  {
    id: 8,
    title: "Women in Private Equity",
    auto: "Preqin",
    date: "February 2019 | Report",
    type: "report",
    listlink:
      "https://docs.preqin.com/reports/Preqin-Women-in-Private-Equity-February-2019.pdf",
    sdata: "Women in Private Equity Preqin February 2019 | Report",
  },
  {
    id: 8,
    title: "One is the loneliest number",
    auto: "McKinsey & Company",
    date: "January 2019 | Article",
    type: "article",
    listlink:
      "https://www.mckinsey.com/featured-insights/gender-equality/one-is-the-loneliest-number",
    sdata: "One is the loneliest numbe McKinsey & Company January 2019 Article",
  },
  {
    id: 8,
    title:
      "Closing the gap: Leadership perspectives on promoting women in financial services",
    auto: "McKinsey & Company",
    type: "article",
    date: "September 2018 | Article",
    listlink:
      "https://www.mckinsey.com/industries/financial-services/our-insights/closing-the-gap-leadership-perspectives-on-promoting-women-in-financial-services",
    sdata:
      "Closing the gap: Leadership perspectives on promoting women in financial services McKinsey & Company September 2018 Article",
  },
  // {
  // 	id: 9,
  // 	title: "The Other Diversity Dividend",
  // 	auto: "Harvard Business Review",
  // 	date:"July 2018 | Article ",
  // 	listlink:"https://hbr.org/2018/07/the-other-diversity-dividend",
  // 	sdata:"The Other Diversity Dividend Harvard Business Review July 2018 Article",
  // },
  {
    id: 9,
    title: "The Other Diversity Dividend",
    auto: "Harvard Business Review",
    type: "article",
    date: "July 2018 | Article ",
    listlink: "https://hbr.org/2018/07/the-other-diversity-dividend",
    sdata:
      "The Other Diversity Dividend Harvard Business Review July 2018 Article",
  },
  {
    id: 9,
    title: "The power of parity: Advancing women’s equality in India, 2018",
    type: "article",
    auto: "McKinsey & Company",
    date: "May 2018 | Article",
    listlink:
      "https://www.mckinsey.com/featured-insights/gender-equality/the-power-of-parity-advancing-womens-equality-in-india-2018",
    sdata:
      "The power of parity: Advancing women’s equality in India, 2018 McKinsey & Company May 2018 Article",
  },
  {
    id: 9,
    title: "The power of parity: Advancing women’s equality in Asia Pacific",
    auto: "McKinsey Global Institute",
    type: "report",
    date: "April 2018 | Report",
    listlink:
      "https://www.mckinsey.com/featured-insights/gender-equality/the-power-of-parity-advancing-womens-equality-in-asia-pacific",
    sdata:
      "The power of parity: Advancing women’s equality in Asia Pacific McKinsey Global Institute April 2018 Report",
  },
  {
    id: 9,
    title: "Delivering through diversity",
    auto: "McKinsey & Company",
    type: "report",
    date: "January 2018 | Report ",
    listlink:
      "https://www.mckinsey.com/business-functions/organization/our-insights/delivering-through-diversity",
    sdata:
      "Delivering through diversity McKinsey & Company January 2018 Report",
  },
  {
    id: 21,
    title: `<div>Venture Capitalists with Daughters Make Better Deals    </div>`,
    auto: "World Economic Forum",
    date: "October 2017 | Article",
    type: "article",
    listlink:
      "https://www.weforum.org/agenda/2017/10/venture-capitalists-with-daughters-make-better-deals/",
    sdata: "Venture Capitalists with Daughters Make Better Deals",
  },
  {
    id: 9,
    title: "Women Matter: Ten years of insights on gender diversity",
    auto: "McKinsey & Company",
    date: "October 2017 | Report",
    type: "report",

    listlink:
      "https://www.mckinsey.com/featured-insights/gender-equality/women-matter-ten-years-of-insights-on-gender-diversity",
    sdata:
      "Women Matter: Ten years of insights on gender diversity McKinsey & Company October 2017 Report",
  },

  {
    id: 10,
    title: "Women in Private Equity",
    auto: "PwC",
    type: "report",
    date: "October 2017 | Report",
    listlink:
      "https://www.pwc.de/en/finanzinvestoren/pwc-women-in-private-equity.pdf",
    sdata: "Women in Private Equity PwC October 2017 Report",
  },
  {
    id: 11,
    title:
      "Diverse Teams Feel Less Comfortable — and That’s Why They Perform Better",
    auto: "Harvard Business Review",
    type: "article",
    date: "September 2016 | Article",
    listlink:
      "https://hbr.org/2016/09/diverse-teams-feel-less-comfortable-and-thats-why-they-perform-better",
    sdata:
      "Diverse Teams Feel Less Comfortable — and That’s Why They Perform Better Harvard Business Review September 2016 Article",
  },
  {
    id: 11,
    title: "Realizing gender equality’s $12 trillion economic opportunity",
    auto: "McKinsey Global Institute",
    type: "report",
    date: "May 2016 | Report",
    listlink:
      "https://www.mckinsey.com/featured-insights/employment-and-growth/realizing-gender-equalitys-12-trillion-economic-opportunity",
    sdata:
      "Realizing gender equality’s $12 trillion economic opportunity McKinsey Global Institute May 2016 Report",
  },
  {
    id: 21,
    title: `<div>The Gender Advantage: Integrating Gender Diversity Into Investment Decisions</div>`,
    auto: "Morgan Stanley",
    date: "March 2016 | Report",
    type: "report",
    listlink:
      "https://www.morganstanley.com/pub/content/dam/msdotcom/ideas/gender-diversity-toolkit/Gender-Diversity-Investing-Primer.pdf",
    sdata: "The Gender Advantage: Integrating Gender Diversity Into Investment Decisions",
  },
  
  {
    id: 11,
    title: "Banks Run By Women Might Be Less Vulnerable In A Crisis",
    auto: "Wall Street Journal ",
    type: "article",
    date: "February 2016 | Article ",
    listlink:
      "https://www.wsj.com/articles/banks-run-by-women-might-be-less-vulnerable-in-a-crisis-1456110317",
    sdata:
      "February 2016 Article Wall Street Journal Banks Run By Women Might Be Less Vulnerable In A Crisis",
  },
  {
    id: 11,
    title:
      "The Power of Parity: How advancing women's equality can add $12 trillion to global growth",
    auto: "McKinsey & Company",
    type: "report",
    date: "September 2015 | Report",
    listlink:
      "https://www.mckinsey.com/~/media/McKinsey/Industries/Public%20and%20Social%20Sector/Our%20Insights/How%20advancing%20womens%20equality%20can%20add%2012%20trillion%20to%20global%20growth/MGI%20Power%20of%20parity_Full%20report_September%202015.pdf",
    sdata:
      "The Power of Parity: How advancing women's equality can add $12 trillion to global growth McKinsey & Company September 2015 Report",
  },
  {
    id: 11,
    title: "Why diversity matters",
    auto: "McKinsey & Company ",
    date: "January 2015 | Article",
    type: "article",
    listlink:
      "https://www.mckinsey.com/business-functions/organization/our-insights/why-diversity-matters",
    sdata: "Why diversity matters McKinsey & Company January 2015 Article",
  },
  {
    id: 11,
    title: "How Diversity Can Drive Innovation",
    auto: "Harvard Business Review ",
    type: "article",
    date: "December 2013 | Article ",
    listlink: "https://hbr.org/2013/12/how-diversity-can-drive-innovation",
    sdata:
      "How Diversity Can Drive Innovation December 2013 Article Harvard Business Review",
  },
  {
    id: 11,
    title: "Gender, Leadership And Organization",
    auto: "Values and Ethics for the 21st Century: BBVA",
    type: "extract",
    date: "April 2012 | Extract",
    listlink:
      "https://www.bbvaopenmind.com/en/articles/gender-leadership-and-organization/",
    sdata:
      "April 2012 Extract Gender, Leadership And Organization Values and Ethics for the 21st Century: BBVA",
  },
  {
    id: 11,
    title:
      "Women Matter 2: : Female Leadership, A Competitive Edge For The Future",
    auto: "McKinsey & Company",
    type: "report",
    date: "October 2008 | Report",
    listlink:
      "https://www.mckinsey.com/~/media/McKinsey/Business%20Functions/Organization/Our%20Insights/Women%20matter/Women_matter_oct2008_english.ashx",
    sdata:
      "October 2008 Report Women Matter 2: : Female Leadership, A Competitive Edge For The Future McKinsey & Company",
  },
  {
    id: 11,
    title: "When The Boss Is A Woman",
    auto: "American Psychological Association",
    type: "article",
    date: "March 2006 | Article",
    listlink: "https://www.apa.org/research/action/boss",
    sdata: "March 2006 Article American Psychological Association",
  },
  {
    id: 11,
    title: "Gender Differences In Leadership Styles And Management Skills",
    type: "article",
    auto: "Women in Management Review",
    date: "August 2001 | Article  ",
    listlink:
      "https://www.emerald.com/insight/content/doi/10.1108/09649420110395728/full/html",
    sdata: "August 2001 Article  ",
  },
];

const videoSection = [
  {
    id: 1,
    videoSrc: v2,
    name: "Ask and You Shall Get feat. Taylor Lawrence,",
    compnay: "EverStone Group",
  },
  {
    id: 2,
    videoSrc: v3,
    name: "Authenticity is Key feat. Anusha Shetty,",
    compnay: "Vaastu Finance",
  },
  {
    id: 3,
    videoSrc: v5,
    name: "Be Bold and Courageous feat. Nisha Kaur Uberoi,",
    compnay: "Trilegal",
  },
  {
    id: 11,
    videoSrc: v11,
    name: "Battling Biases  feat. Anshul Jain,",
    compnay: "Lighthouse Advisors",
  },
  {
    id: 13,
    videoSrc: v13,
    name: "Best of Both Worlds feat. Nidhi Prabhakar,",
    compnay: "Multiples Alternate Asset Management",
    skey: "Nidhi Prabhakar",
  },
  {
    id: 12,
    videoSrc: v12,
    name: "Empathy and Respect feat. RM Vishakha, ",
    compnay: "India First Life Insurance",
  },
  {
    id: 14,
    videoSrc: v14,
    name: "Financial Inclusion Powered by Gender Parity  feat. Hardika Shah,",
    compnay: "Kinara Capital",
  },
  {
    id: 4,
    videoSrc: v6,
    name: "Invest in Building Knowledge feat. Koel Kumar,",
    compnay: "EverStone Capital",
  },
  {
    id: 5,
    videoSrc: v8,
    name:
      "Making Inroads into Traditionally Male Industries feat. Manju Dhawan,",
    compnay: "Ecom Express Private Limited",
  },
  {
    id: 6,
    videoSrc: v9,
    name: "My Life Lessons feat. Roshini Bakshi,",
    compnay: "EverStone Capital",
  },
  {
    id: 7,
    videoSrc: v4,
    name: "Sky Sans Ceilings feat. Nupur Garg,",
    compnay: "Winpe Forum",
  },
  {
    id: 8,
    videoSrc: v1,
    name: "Shattering Stereotypes feat. Bhavna Thakur,",
    compnay: "EverStone Capital",
  },
  {
    id: 9,
    videoSrc: v7,
    name: "Together We Can Do It feat. Varsha Poddar & Poonam Puri,",
    compnay: "CDPQ",
  },
  {
    id: 10,
    videoSrc: v10,
    name: "The Likeability Bias feat. Nithya Easwaran,",
    compnay: "Multiples Alternate Asset Management",
  },
];
const newsletter = [
  {
    id: 21,
    title: `<div>Winpe Annual Report 2026: Compounding Change: The Next Five Years of Gender Intelligent Capital

</div>`,
    auto: " ",
    datee: "31 Mar 2026",
   
    listlink:
      "/WinpeAnnualReport2026/",
   
  },
  {
    id: 21,
    title: `<div>Winpe at Five: Changing the Face of Investing Through DEI</div>`,
    auto: " ",
    datee: "27 Mar 2025",
   
    listlink:
      "/WinpeAtFive/",
   
  },
  {
    id: 21,
    title: `<div>JAN 2025 Edition: Celebrating 5 Years of Winpe</div>`,
    auto: " ",
    datee: "19 Jan 2025",
   
    listlink:
      "/5YearsofWinpe/",
   
  },
  {
    id: 21,
    title: `<div>Equity in Action: Winpe's Gender Diversity Chronicle</div>`,
    auto: " ",
    datee: "24 April 2024",
   
    listlink:
      "/EquityinAction/",
   
  },
  {
    id: 0,
    title: `<div>Winpe Quarterly Newsletter | August 2023 </div>`,
    auto: " ",
    datee: "09 Aug 2023",
    listlink: "/newsletter-aug2023",
  },
  {
    id: 0,
    title: `<div>Winpe Report - WLSA & Others  </div>`,
    auto: " ",
    datee: "23 May 2023",
    listlink: "/winpereport-wlsa",
  },
  {
    id: 0,
    title: `<div>In gratitude for our work together - 2022 Rewinded   </div>`,
    auto: " ",
    datee: "9 Jan 2023",
    listlink: "/yearlynewsletter2022",
  },
  {
    id: 0,
    title: `<div>Quarter in Focus  </div>`,
    auto: "April - June 2022",
    datee: "9 August 2022",
    listlink: "/quaterlynewsletterjuly2022",
  },
  {
    id: 0,
    title: `<div>Winpe Quarterly Newsletter</div>`,
    auto: " ",
    datee: "29 April 2022",
    listlink: "/quaterlynewsletterapril2022",
  },
  {
    id: 0,
    title: `<div>365 Days of Winpe | Yearly Round-Up    </div>`,
    auto: " ",
    datee: "31 Dec 2021",
    listlink: "/yearlynewsletter2021",
  },
  {
    id: 0,
    title: `<div>Winpe Report Card and More | Quarterly Newsletter</div>`,
    auto: "July - Sep 2021",
    datee: "29 Oct 2021",
    listlink: "/quarterlynewslettersep2021",
  },
  {
    id: 0,
    title: `<div>Winpe Quarterly Newsletter </div>`,
    auto: "April - June 2021",
    datee: "10 July 2021",
    listlink: "/quarterlynewsletterjune2021",
  },
  {
    id: 0,
    title: `<div>Winpe Quarterly Newsletter</div>`,
    auto: "January - March 2021",
    datee: "26 April 2021",
    listlink: "/quarterlynewslettermarch2021",
  },
  {
    id: 0,
    title: `<div>Walk into the new year with Winpe</div>`,
    auto: "",
    datee: "12 January 2021",
    listlink: "/newyearwithwinpe",
  },
  {
    id: 0,
    title: `<div>Winpe Quarterly Newsletter</div>`,
    auto: "July - September 2020",
    datee: "22 October 2020",
    listlink: "/quarterlyNewsletterSeptember",
  },
  {
    id: 0,
    title: `<div>Winpe Quarterly Newsletter</div>`,
    auto: "April - June 2020",
    datee: "20 July 2020",
    listlink: "/quarterlyNewsletterJune",
  },
  {
    id: 1,
    title: `<div>Winpe Quarterly Newsletter</div>`,
    auto: "January - March 2020",
    datee: "20 April 2020",
    listlink: "/quarterlyNewsletter",
  },
];

export {
  TabContent,
  pressContent,
  knowledgeResources,
  videoSection,
  blogsContent,
  newsletter,
};



// WEBPACK FOOTER //
// ./src/constant/blogConstant.js